import { Component, computed, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ImpersonationBannerComponent } from './components/impersonation-banner/impersonation-banner.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LegalDialogComponent, LegalSection } from './shared/dialogs/legal-dialog/legal-dialog.component';
import { APP_VERSION } from './shared/app-version';


import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NavbarComponent,
    ImpersonationBannerComponent,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  readonly marca = environment.marca;
  private auth = inject(AuthService);
  private router = inject(Router);
  private dialog = inject(MatDialog);

  readonly appVersion = APP_VERSION;

  userLoggedIn = signal(false);
  isAuthStateLoaded = signal(false);
  currentRoute = signal(this.router.url);

  constructor() {
    // Suscribirse al estado de autenticación
    effect(() => {
      this.auth.currentUser.subscribe(user => {
        this.userLoggedIn.set(!!user);
        this.isAuthStateLoaded.set(true);
//        console.log('[DEBUG] authStateLoaded:', true, 'userLoggedIn:', !!user);
      });
    });

    // Suscribirse a cambios de ruta
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute.set(event.urlAfterRedirects);
//        console.log('[DEBUG] router changed to', event.urlAfterRedirects);
      });

    // Debug de evaluación
    effect(() => {
//      console.log('[DEBUG] showNavbar:', this.showNavbar());
    });
  }

  showNavbar = computed(() => {
    const url = this.currentRoute();
    return this.isAuthStateLoaded() && this.userLoggedIn() && !['/login', '/register'].includes(url);
  });

  openLegal(section: LegalSection) {
    this.dialog.open(LegalDialogComponent, { data: { section }, width: '640px', maxHeight: '90vh' });
  }
}
